/* eslint-disable camelcase */
import React from 'react'
import { Col, Block, H2, H3, BodyCopy } from '../../Globals'
import { Row, Column } from '@components/Common'
import { richTextToComponents } from '../../../utils/gatsby/richTextToComponents'
import sideBgImage from '@assets/images/Right_Faded_BW.jpg'
import { StyledContentContainer, StyledA } from '../style'
import { generateRandomKey } from '@utils'
import { ProfileCard } from '../../Card/index'
import Html from '../../Html'
import Callout from './Callout'

const Overview = ({
  content,
  descriptionHtml,
  practiceChairs: { title, professionals },
  relatedPracticeAreas,
  callouts,
}) => {
  return (
    <Block imgUrl={sideBgImage} padding="0px">
      <StyledContentContainer>
        <Row>
          {/* Replacing this Col component is causing excessive 
          margins from empty p tags. Figure out why */}
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={8}
            xl={8}
            padding="15px"
            marginRight="25"
          >
            {descriptionHtml?.useHTMLField === 'true' &&
            descriptionHtml?.html ? (
              <Html contentHtml={descriptionHtml} />
            ) : (
              richTextToComponents(content)
            )}
          </Col>
          <Column className="max-w-[540px] w-full mt-[55px] ml-[15px] lg:ml-10 lg:w-[20%] xl:ml-[8.33%]">
            {professionals?.length > 0 && (
              <>
                <H2 fontSize="1rem" marginTop={30}>
                  {title || 'Contact Us'}
                </H2>

                {professionals?.map(professional => (
                  <>
                    <ProfileCard
                      key={generateRandomKey()}
                      person={professional}
                      id={professional.id}
                      displayTitle
                      displayAvatar
                      defaultFontSize={14}
                      contactUs
                      float="left"
                      height="auto"
                    />
                  </>
                ))}
              </>
            )}
            {relatedPracticeAreas?.length > 0 && (
              <>
                <H3 marginBottom={12} fontSize="14px" color="gray">
                  Related Practice Areas
                </H3>
                {relatedPracticeAreas?.map(practiceArea => (
                  <BodyCopy key={practiceArea.id}>
                    <StyledA
                      to={practiceArea?.slug}
                      contentType={'ContentfulPracticeArea'}
                    >
                      {practiceArea.title}
                    </StyledA>
                  </BodyCopy>
                ))}
                <br />
              </>
            )}
            {callouts?.map((callout, i) => (
              <Callout key={`${i} + ${callout?.contentful_id}`} {...callout} />
            ))}
          </Column>
        </Row>
      </StyledContentContainer>
    </Block>
  )
}

Overview.propTypes = {}

export default Overview
